import {
  EVENT_TRACKER_TIME,
  MULTIPLE_BATCHES,
  MANUALLY_ADDED,
  SCANNED_PRODUCT,
  PREV_ADDED_PRODUCT_TIME,
  TOTAL_PRODUCTS,
  PRODUCT_ADD_AVG_TIME,
  PRODUCT_ADD_TIME_ARRAY,
  PRODUCT_REMOVE_TIME_ARRAY,
  EDIT_ORDER_ITEM,
  MANUALLY_ADDED_BARCODES_ARRAY,
  MANUALLY_REMOVED_ITEMS,
  RESET_STATE,
  MANUAL_ITEMS_GTIN,
  RESET_STATE_WITHOUT_TIME,
} from "../Actions/eventTracker";

const orderMetricBackupData = localStorage.getItem("orderMetricData");
const orderMetricData = orderMetricBackupData ? JSON.parse(orderMetricBackupData) : undefined;

const initState = {
  startTime: orderMetricData?.startTime || "",
  prevAddedProductTime: orderMetricData?.prevAddedProductTime || "",
  startTimeAdded: orderMetricData?.startTimeAdded || false,
  manuallyAdded: orderMetricData?.manuallyAdded || 0,
  scannedProduct: orderMetricData?.scannedProduct || 0,
  isMultipleBatch: orderMetricData?.isMultipleBatch || false,
  avgProductAddTime: orderMetricData?.avgProductAddTime || "",
  totalProducts: orderMetricData?.totalProducts || 0,
  productTimeArray: orderMetricData?.productTimeArray || [],
  editOrderItem: orderMetricData?.editOrderItem || 0,
  manuallyRemovedItems: orderMetricData?.manuallyRemovedItems || 0,
  manualItemsGtin: orderMetricData?.manualItemsGtin || [],
};

export const eventTrackerReducer = (state = initState, action) => {
  switch (action.type) {
    case EVENT_TRACKER_TIME: {
      return {
        ...state,
        startTime: action.payload.startTime,
        startTimeAdded: action.payload.startTimeAdded,
      };
    }
    case MANUALLY_ADDED: {
      return {
        ...state,
        manuallyAdded: action.payload,
      };
    }
    case SCANNED_PRODUCT: {
      return {
        ...state,
        scannedProduct: action.payload,
      };
    }
    case MULTIPLE_BATCHES: {
      return {
        ...state,
        isMultipleBatch: action.payload,
      };
    }
    case PRODUCT_ADD_AVG_TIME: {
      return {
        ...state,
        avgProductAddTime: action.payload,
      };
    }
    case TOTAL_PRODUCTS: {
      return {
        ...state,
        totalProducts: action.payload,
      };
    }
    case PREV_ADDED_PRODUCT_TIME: {
      return {
        ...state,
        prevAddedProductTime: action.payload,
      };
    }
    case PRODUCT_ADD_TIME_ARRAY: {
      return {
        ...state,
        productTimeArray: [...state.productTimeArray, action.payload],
      };
    }
    case PRODUCT_REMOVE_TIME_ARRAY: {
      return {
        ...state,
        productTimeArray: [],
      };
    }
    case EDIT_ORDER_ITEM: {
      return {
        ...state,
        editOrderItem: action.payload,
      };
    }
    case MANUALLY_REMOVED_ITEMS: {
      return {
        ...state,
        manuallyRemovedItems: action.payload,
      };
    }
    case MANUAL_ITEMS_GTIN: {
      return {
        ...state,
        manualItemsGtin: state.manualItemsGtin.includes(action.payload)
          ? [...state.manualItemsGtin]
          : [...state.manualItemsGtin, action.payload],
      };
    }
    case RESET_STATE: {
      return {
        startTime: "",
        prevAddedProductTime: "",
        startTimeAdded: false,
        manuallyAdded: 0,
        scannedProduct: 0,
        isMultipleBatch: false,
        avgProductAddTime: "",
        totalProducts: 0,
        productTimeArray: [],
        editOrderItem: 0,
        manuallyRemovedItems: 0,
        manualItemsGtin: [],
      };
    }
    case RESET_STATE_WITHOUT_TIME: {
      return {
        ...state,
        manuallyAdded: 0,
        scannedProduct: 0,
        isMultipleBatch: false,
        avgProductAddTime: "",
        totalProducts: 0,
        productTimeArray: [],
        editOrderItem: 0,
        manuallyRemovedItems: 0,
        manualItemsGtin: [],
      };
    }
    default:
      return state;
  }
};

// export const searchTextVal = state => state.pagination.searchText;
export const getEventTimeDetails = (state) => state.eventTime;
export const getManuallyAddedProduct = (state) => state.eventTime.manuallyAdded;
export const getScannedProduct = (state) => state.eventTime.scannedProduct;
export const getMultipleBatchValue = (state) => state.eventTime.isMultipleBatch;
export const getAvgProductAdditionTime = (state) => state.eventTime.avgProductAddTime;
export const getTotalProducts = (state) => state.eventTime.totalProducts;
export const getPrevAddedProductTime = (state) => state.eventTime.prevAddedProductTime;
export const getFullState = (state) => state.eventTime;
export const getProductTimeArray = (state) => state.eventTime.productTimeArray;
export const getEditOrderedProduct = (state) => state.eventTime.editOrderItem;
export const getManuallyRemovedItems = (state) => state.eventTime.manuallyRemovedItems;
export const getManuallyAddedGtinArray = (state) => state.eventTime.manualItemsGtin;